export   const deleteMultipleCache = (cacheArray:any) => {
    for (var i = 0; i < cacheArray.length; i++) {
      if ("caches" in window) {
        caches.delete(cacheArray[i]).then(function (res) {
          return res;
        });
      }
    }
  };